<style>
.label {
    color: #808CA3;
    font-weight: normal;
    font-size: 70%;
    text-transform: uppercase;
}


</style>

<template>

    <div class="modal fade course-schedules-details" ref="courseScheduleOrderModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="courseSchedule">
                        #{{ courseSchedule.id }} {{ courseSchedule.course.name }}
                    </h5>
                    <button type="button" class="btn-close" @click="hide()" aria-label="Close"></button>
                </div>
                <div class="modal-body" v-if="courseSchedule">
                    <div class="row guest-list my-2">
                        <div v-for="guest in guests" class="col-sm">
                            <button class="btn btn-sm btn-success" v-if="isOrderedByGuest(guest)"
                                    @click="cancelCourseOrder(guest)" title="cancel the order">
                                #{{ guest.user.id }} {{ guest.user.name }}
                                [{{ guest.path }}] <span v-if="guest.room">Room {{ guest.room.number }}]</span>
                            </button>
                            <button class="btn btn-sm btn-outline-secondary" v-else
                                    @click="order(guest)" title="make new order" :disabled="!isGuestAvailable(guest)">
                                #{{ guest.user.id }} {{ guest.user.name }}
                                [{{ guest.path }}] <span v-if="guest.room">Room {{ guest.room.number }}]</span>
                            </button>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-4 label">Path</div>
                        <div class="col-md-8">
                            {{ courseSchedule.path.name }}
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-4 label">Status</div>
                        <div class="col-md-8">
                            <span v-if="courseSchedule.is_active" class="text-success">active</span>
                            <span v-else class="text-danger">not active</span>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-4 label">Date</div>
                        <div class="col-md-8">
                            {{ dateFormat(courseSchedule.from, 'dddd, D MMM') }}
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-4 label">Time</div>
                        <div class="col-md-8">
                            from {{ dateFormat(courseSchedule.from, 'h:mm a') }} till
                            {{ dateFormat(courseSchedule.till, 'h:mm a') }}
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-4 label">Class</div>
                        <div class="col-md-8">
                            <a target="_blank" :href="courseSchedule.course.link">{{
                                    courseSchedule.course.name
                                }}</a>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-4 label">Trainer</div>
                        <div class="col-md-8">
                                <span v-if="courseSchedule.trainer">
                                    <a target="_blank"
                                       :href="courseSchedule.trainer.link">{{ courseSchedule.trainer.name }}</a>
                                </span>
                            <span v-else>no</span>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-4 label">Level</div>
                        <div class="col-md-8">
                            {{ courseSchedule.level.name }}
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-4 label">Capacity</div>
                        <div class="col-md-8">
                            {{ courseSchedule.capacity - courseSchedule.guest_ids.length }} / {{ courseSchedule.capacity }}
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-4 label">Location</div>
                        <div class="col-md-8">
                            <div v-if="courseSchedule.location">
                                <a target="_blank" :href="courseSchedule.location.link">{{
                                        courseSchedule.location.name
                                    }}</a>
                            </div>
                            <span
                                v-if="courseSchedule.location_comment"><em>{{
                                    courseSchedule.location_comment
                                }}</em></span>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <div style="margin-right: auto" v-if="courseSchedule">
                        <a :href="courseSchedule.url" class="btn btn-info" v-if="courseSchedule.url" target="_blank">Open
                            in new tab</a>
                        <button type="button" class="btn btn-info" @click="refresh()">Refresh</button>
                    </div>
                    <button type="button" class="btn btn-secondary" @click="hide()">Close</button>
                </div>

            </div>
        </div>
    </div>

</template>

<script>

const mixinDayJs = require('../../helpers/vue_mixins').mixinDayJs;
const mixinErrorHandler = require('../../helpers/vue_mixins').mixinErrorHandler;
import {Modal} from 'bootstrap'

export default {
    mixins: [mixinDayJs, mixinErrorHandler],
    props: {
        course_schedule: Object,
        library: Object,
        api_urls: Object,
        reset_session: Object,
        permissions: Object,
        booking: Object
    },
    data() {
        return {
            courseSchedule: null,
            modal: null,
            loading: false,
            courseOrders: [],
            guestsAvailability: [],
            allow: {
                create: true,
                edit: true,
                show: true,
            }
        }
    },
    mounted() {
        this.init();
    },
    methods: {

        init() {
            this.loading = false;
            if (this.permissions) {
                _.merge(this.allow, this.permissions);
            }
            this.courseSchedule = this.course_schedule;
            this.getCourseOrders();
            if (!this.modal) {
                this.modal = new Modal(this.$refs.courseScheduleOrderModal);
            }
            this.modal.show();
            if (!this.modal.visible) {
                this.modal.show();
            }
        },

        getCourseOrders() {
            this.getGuestsAvailability();
            const url = _.replace(this.$root.apiUrls.course_schedule.course_orders, 'COURSE_SCHEDULE_ID', this.courseSchedule.id);
            //console.log(url);
            this.$root.api.get(url).then(response => {
                if (this.$root.checkNoError(response)) {
                    this.courseOrders = response.data;
                }

            }).catch(e => {
                this.$root.alertApiError(e, this.$root.api);
            });
        },

        isOrderedByGuest(guest) {
            const order = this.getOrderForGuest(guest);

            if (order) {
                return true;
            }

            return false;
        },

        isGuestAvailable(guest) {
            let data = _.find(this.guestsAvailability, g => g.id === guest.user.id);
            if (_.isUndefined(data)) {
                return false;
            }

            return true;
        },

        getOrderForGuest(guest) {
            return _.find(this.courseOrders, o => guest.user.id === o.user_id && this.booking.id === o.booking_id);
        },

        cancelCourseOrder(guest) {
            if (confirm('You are going to cancel the order? Are you sure?')) {
                const order = this.getOrderForGuest(guest);
                if (order) {
                    let url = _.replace(this.$root.apiUrls.course_schedule.cancel, 'COURSE_SCHEDULE_ID', this.courseSchedule.id);
                    url = _.replace(url, 'BOOKING_USER_ID', guest.id);
                    this.courseOrders = _.filter(this.courseOrders, o => o.id !== order.id);
                    this.courseSchedule.guest_ids = _.filter(this.courseSchedule.guest_ids, o => parseInt(o) !==  parseInt(guest.user.id));
                    this.courseSchedule.users = _.filter(this.courseSchedule.users, u => parseInt(u.id) !== parseInt(guest.user.id));

                    this.$root.api.get(url).then(response => {
                        if (this.$root.checkNoError(response)) {
                            this.getCourseOrders();
                        }
                    }).catch(e => {
                        this.$root.alertApiError(e, this.$root.api);
                    });
                }
            }
        },

        order(guest) {
            let url = _.replace(this.$root.apiUrls.course_schedule.order, 'COURSE_SCHEDULE_ID', this.courseSchedule.id);
            url = _.replace(url, 'BOOKING_USER_ID', guest.id);
            this.$root.api.get(url).then(response => {
                if (this.$root.checkNoError(response)) {
                    this.courseOrders.push(response.data);
                    this.courseSchedule.guest_ids.push(guest.user.id);
                    this.courseSchedule.users.push(response.data.user);
                    this.refresh();
                }
            }).catch(e => {
                this.$root.alertApiError(e, this.$root.api);
            });
        },

        hide() {
            this.modal.hide();
            this.$emit('closed', {course_schedule: this.courseSchedule});
        },

        refresh() {
            this.getCourseOrders();
            this.$emit('refresh', {course_schedule: this.courseSchedule});
            this.courseSchedule = null;
        },

        getGuestsAvailability() {
            let url = _.replace(this.$root.apiUrls.course_schedule.availability, 'COURSE_SCHEDULE_ID', this.courseSchedule.id);
            this.$root.api.get(url).then(response => {
                if (this.$root.checkNoError(response)) {
                    this.guestsAvailability = response.data;
                }
            }).catch(e => {
                this.$root.alertApiError(e, this.$root.api);
            });
        },

        getRoomParamForGuest: function (guestId, roomParam = null) {
            const bookingUser = _.find(this.guests, (el) => el.user.id === guestId);
            if (bookingUser) {
                if (roomParam) {
                    return bookingUser.room[roomParam];
                }

                return bookingUser.room;
            }
        },

        getGuestParam: function (guestId, param = null) {
            const bookingUser = _.find(this.guests, (el) => el.user.id === guestId);
            if (bookingUser) {
                if (param) {
                    return bookingUser.user[param];
                }

                return bookingUser.user;
            }
        },
    },

    watch: {
        course_schedule(newVal, oldVal) {
            this.init();
        }
    },
    computed: {
        guests: function () {
            if (this.booking) {
                return this.booking.guests;
            }

            return [];
        }

    }
}
</script>
